export const InstructionUsage = {
  BOOKING: 'BOOKING',
  QUOTING: 'QUOTING',
} as const;
export type InstructionUsage = (typeof InstructionUsage)[keyof typeof InstructionUsage];
export const AgentExecutionStatus = {
  Running: 'Running',
  Success: 'Success',
  Invalid: 'Invalid',
  Error: 'Error',
} as const;
export type AgentExecutionStatus = (typeof AgentExecutionStatus)[keyof typeof AgentExecutionStatus];
export const ProviderDataMapType = {
  API_SURCHARGE_NAME_TO_PELI_SURCHARGE_TYPE: 'API_SURCHARGE_NAME_TO_PELI_SURCHARGE_TYPE',
  API_FLIGHT_SEGMENT_STATUS_TO_PELI_FLIGHT_SEGMENT_STATUS: 'API_FLIGHT_SEGMENT_STATUS_TO_PELI_FLIGHT_SEGMENT_STATUS',
} as const;
export type ProviderDataMapType = (typeof ProviderDataMapType)[keyof typeof ProviderDataMapType];
export const DataType = {
  STRING: 'STRING',
  NUMBER: 'NUMBER',
  DATE: 'DATE',
  BOOLEAN: 'BOOLEAN',
  JSON: 'JSON',
  IGNORE: 'IGNORE',
} as const;
export type DataType = (typeof DataType)[keyof typeof DataType];
export const OnboardingStep = {
  CONFIRM: 'CONFIRM',
  PERSONAL: 'PERSONAL',
  COMPANY: 'COMPANY',
  COMPANY_SELECT: 'COMPANY_SELECT',
  SIGNATURE: 'SIGNATURE',
  INVITE: 'INVITE',
  COMPLETE: 'COMPLETE',
} as const;
export type OnboardingStep = (typeof OnboardingStep)[keyof typeof OnboardingStep];
export const RuleType = {
  CAN_SET_QUOTE_TO_IN_PROGRESS: 'CAN_SET_QUOTE_TO_IN_PROGRESS',
  WEIGHT_SELECTION_FOR_SURCHARGE: 'WEIGHT_SELECTION_FOR_SURCHARGE',
  CAN_EXTEND_ETT: 'CAN_EXTEND_ETT',
  DEFAULT_SPOT_VALIDITY: 'DEFAULT_SPOT_VALIDITY',
  DIMENSION_RESTRICTIONS: 'DIMENSION_RESTRICTIONS',
  AWB_BOOKING_RESTRICTIONS: 'AWB_BOOKING_RESTRICTIONS',
  DYNAMIC_WEIGHT_BREAK_RESTRICTIONS: 'DYNAMIC_WEIGHT_BREAK_RESTRICTIONS',
} as const;
export type RuleType = (typeof RuleType)[keyof typeof RuleType];
export const EmailThreadType = {
  Other: 'Other',
  Customer: 'Customer',
  Airline: 'Airline',
} as const;
export type EmailThreadType = (typeof EmailThreadType)[keyof typeof EmailThreadType];
export const ExpiryReason = {
  SUCCEEDED: 'SUCCEEDED',
  ROUTE_ENDED: 'ROUTE_ENDED',
  INVALID_ENTRY: 'INVALID_ENTRY',
} as const;
export type ExpiryReason = (typeof ExpiryReason)[keyof typeof ExpiryReason];
export const CostUnitType = {
  CURRENCY: 'CURRENCY',
  PERCENTAGE: 'PERCENTAGE',
} as const;
export type CostUnitType = (typeof CostUnitType)[keyof typeof CostUnitType];
export const SurchargeUnit = {
  KG: 'KG',
  AWB: 'AWB',
  UN: 'UN',
  FLAT: 'FLAT',
} as const;
export type SurchargeUnit = (typeof SurchargeUnit)[keyof typeof SurchargeUnit];
export const SurchargeWeightType = {
  CHARGEABLE_WEIGHT: 'CHARGEABLE_WEIGHT',
  GROSS_WEIGHT: 'GROSS_WEIGHT',
} as const;
export type SurchargeWeightType = (typeof SurchargeWeightType)[keyof typeof SurchargeWeightType];
export const LineItemAudience = {
  CUSTOMER: 'CUSTOMER',
  FULFILLMENT_PARTNER: 'FULFILLMENT_PARTNER',
  TENANT: 'TENANT',
  SYSTEM: 'SYSTEM',
} as const;
export type LineItemAudience = (typeof LineItemAudience)[keyof typeof LineItemAudience];
export const MarkupConfigurationType = {
  FULFILLMENT_PARTNER: 'FULFILLMENT_PARTNER',
  SYSTEM: 'SYSTEM',
  TENANT: 'TENANT',
} as const;
export type MarkupConfigurationType = (typeof MarkupConfigurationType)[keyof typeof MarkupConfigurationType];
export const SurchargeCategory = {
  FUEL: 'FUEL',
  SECURITY: 'SECURITY',
  SCREENING: 'SCREENING',
  NON_EAWB: 'NON_EAWB',
  FWL_FHL_EDI: 'FWL_FHL_EDI',
  UN_FEE: 'UN_FEE',
  TRUCKING: 'TRUCKING',
  LI_BATTERY: 'LI_BATTERY',
  DRY_ICE: 'DRY_ICE',
  NON_STACKABLE: 'NON_STACKABLE',
  UNKNOWN_SHIPPER: 'UNKNOWN_SHIPPER',
  MAINDECK: 'MAINDECK',
  OVERLENGTH: 'OVERLENGTH',
  MANUAL_BOOKING: 'MANUAL_BOOKING',
  DISRUPTION: 'DISRUPTION',
  PICK_UP: 'PICK_UP',
  AWB_LABELING: 'AWB_LABELING',
  TRANSFER: 'TRANSFER',
  HAZARDOUS: 'HAZARDOUS',
  DOCUMENT_PRINTING: 'DOCUMENT_PRINTING',
} as const;
export type SurchargeCategory = (typeof SurchargeCategory)[keyof typeof SurchargeCategory];
export const RateCategory = {
  TARIFF: 'TARIFF',
  CONTRACT: 'CONTRACT',
  PROMO: 'PROMO',
  SPOT: 'SPOT',
} as const;
export type RateCategory = (typeof RateCategory)[keyof typeof RateCategory];
export const InlandCategory = {
  PICK_UP: 'PICK_UP',
  AWB_LABELING: 'AWB_LABELING',
  TRANSFER: 'TRANSFER',
  HAZARDOUS: 'HAZARDOUS',
  DOCUMENT_PRINTING: 'DOCUMENT_PRINTING',
} as const;
export type InlandCategory = (typeof InlandCategory)[keyof typeof InlandCategory];
export const MarkupCategory = {
  FULFILLMENT_PARTNER_MARKUP: 'FULFILLMENT_PARTNER_MARKUP',
  TENANT_MARKUP: 'TENANT_MARKUP',
  SYSTEM_MARKUP: 'SYSTEM_MARKUP',
  OTHER_MARKUP: 'OTHER_MARKUP',
} as const;
export type MarkupCategory = (typeof MarkupCategory)[keyof typeof MarkupCategory];
export const LineItemType = {
  TARIFF: 'TARIFF',
  CONTRACT: 'CONTRACT',
  PROMO: 'PROMO',
  SPOT: 'SPOT',
  FUEL: 'FUEL',
  SECURITY: 'SECURITY',
  SCREENING: 'SCREENING',
  NON_EAWB: 'NON_EAWB',
  FWL_FHL_EDI: 'FWL_FHL_EDI',
  UN_FEE: 'UN_FEE',
  TRUCKING: 'TRUCKING',
  LI_BATTERY: 'LI_BATTERY',
  DRY_ICE: 'DRY_ICE',
  NON_STACKABLE: 'NON_STACKABLE',
  UNKNOWN_SHIPPER: 'UNKNOWN_SHIPPER',
  MAINDECK: 'MAINDECK',
  OVERLENGTH: 'OVERLENGTH',
  MANUAL_BOOKING: 'MANUAL_BOOKING',
  DISRUPTION: 'DISRUPTION',
  FULFILLMENT_PARTNER_MARKUP: 'FULFILLMENT_PARTNER_MARKUP',
  TENANT_MARKUP: 'TENANT_MARKUP',
  SYSTEM_MARKUP: 'SYSTEM_MARKUP',
  OTHER_MARKUP: 'OTHER_MARKUP',
  PICK_UP: 'PICK_UP',
  AWB_LABELING: 'AWB_LABELING',
  TRANSFER: 'TRANSFER',
  HAZARDOUS: 'HAZARDOUS',
  DOCUMENT_PRINTING: 'DOCUMENT_PRINTING',
  OTHER: 'OTHER',
} as const;
export type LineItemType = (typeof LineItemType)[keyof typeof LineItemType];
export const ServiceType = {
  General: 'General',
  Expedited: 'Expedited',
  Urgent: 'Urgent',
  Other: 'Other',
} as const;
export type ServiceType = (typeof ServiceType)[keyof typeof ServiceType];
export const QuoteStatus = {
  Pending: 'Pending',
  InProgress: 'InProgress',
  SentToCarrier: 'SentToCarrier',
  ReadyForQC: 'ReadyForQC',
  BookingRequested: 'BookingRequested',
  BookingPending: 'BookingPending',
  Confirmed: 'Confirmed',
  Expired: 'Expired',
} as const;
export type QuoteStatus = (typeof QuoteStatus)[keyof typeof QuoteStatus];
export const FieldSource = {
  Human: 'Human',
  Ai: 'Ai',
} as const;
export type FieldSource = (typeof FieldSource)[keyof typeof FieldSource];
export const FieldApplyOutcome = {
  Filled: 'Filled',
  MatchedExisting: 'MatchedExisting',
  MismatchedExisting: 'MismatchedExisting',
  SkippedNotBlank: 'SkippedNotBlank',
  SkippedUnresolved: 'SkippedUnresolved',
} as const;
export type FieldApplyOutcome = (typeof FieldApplyOutcome)[keyof typeof FieldApplyOutcome];
export const RequestDraftStatus = {
  Pending: 'Pending',
  Approved: 'Approved',
  Discarded: 'Discarded',
} as const;
export type RequestDraftStatus = (typeof RequestDraftStatus)[keyof typeof RequestDraftStatus];
export const RequestDraftRoute = {
  CreateRequest: 'CreateRequest',
  ChangeQuote: 'ChangeQuote',
  UpdateRequest: 'UpdateRequest',
  QuoteUpdate: 'QuoteUpdate',
  BookingConfirmation: 'BookingConfirmation',
  ScheduleChange: 'ScheduleChange',
  TruckingUpdate: 'TruckingUpdate',
  InvoiceBilling: 'InvoiceBilling',
  TariffOffer: 'TariffOffer',
  ComplaintEscalation: 'ComplaintEscalation',
  Other: 'Other',
} as const;
export type RequestDraftRoute = (typeof RequestDraftRoute)[keyof typeof RequestDraftRoute];
export const RequestStatus = {
  New: 'New',
  QuotingInProgress: 'QuotingInProgress',
  QuotingPending: 'QuotingPending',
  QuotingComplete: 'QuotingComplete',
  BookingRequested: 'BookingRequested',
  BookingPending: 'BookingPending',
  BookingComplete: 'BookingComplete',
  BookingChange: 'BookingChange',
  BookingCancel: 'BookingCancel',
  InfoPending: 'InfoPending',
  Cancelled: 'Cancelled',
} as const;
export type RequestStatus = (typeof RequestStatus)[keyof typeof RequestStatus];
export const ShipmentStatus = {
  PENDING: 'PENDING',
  PICKUP_SCHEDULED: 'PICKUP_SCHEDULED',
  PICKUP_COMPLETE: 'PICKUP_COMPLETE',
  AT_WAREHOUSE: 'AT_WAREHOUSE',
  OUT_FOR_DELIVERY: 'OUT_FOR_DELIVERY',
  AIRLINE_ACCEPTED: 'AIRLINE_ACCEPTED',
  DEPARTED: 'DEPARTED',
  ARRIVED: 'ARRIVED',
  DELIVERED: 'DELIVERED',
  ON_HOLD: 'ON_HOLD',
} as const;
export type ShipmentStatus = (typeof ShipmentStatus)[keyof typeof ShipmentStatus];
export const PaymentStatus = {
  PENDING: 'PENDING',
  READY_TO_INVOICE: 'READY_TO_INVOICE',
  INVOICED: 'INVOICED',
  PAID: 'PAID',
  OVERDUE: 'OVERDUE',
  NON_APPLICABLE: 'NON_APPLICABLE',
} as const;
export type PaymentStatus = (typeof PaymentStatus)[keyof typeof PaymentStatus];
export const ShipmentFormPayment = {
  PRE_PAID: 'PRE_PAID',
  COLLECT: 'COLLECT',
} as const;
export type ShipmentFormPayment = (typeof ShipmentFormPayment)[keyof typeof ShipmentFormPayment];
export const FreightStatus = {
  Quoting: 'Quoting',
  Confirmed: 'Confirmed',
} as const;
export type FreightStatus = (typeof FreightStatus)[keyof typeof FreightStatus];
export const HandlingOptions = {
  Stackable: 'Stackable',
  NonStackable: 'NonStackable',
  Drums: 'Drums',
  Pails: 'Pails',
  Supersacks: 'Supersacks',
  RequiredOrientation: 'RequiredOrientation',
  Fragile: 'Fragile',
  TopLoadOnly: 'TopLoadOnly',
} as const;
export type HandlingOptions = (typeof HandlingOptions)[keyof typeof HandlingOptions];
export const DimensionUnit = {
  cm: 'cm',
  in: 'in',
} as const;
export type DimensionUnit = (typeof DimensionUnit)[keyof typeof DimensionUnit];
export const WeightUnit = {
  kg: 'kg',
  lb: 'lb',
} as const;
export type WeightUnit = (typeof WeightUnit)[keyof typeof WeightUnit];
export const CargoType = {
  GeneralCargo: 'GeneralCargo',
  Perishable: 'Perishable',
  DangerousGoods: 'DangerousGoods',
  Pharma: 'Pharma',
  Valuable: 'Valuable',
} as const;
export type CargoType = (typeof CargoType)[keyof typeof CargoType];
export const CargoTypeSub = {
  GENERAL: 'GENERAL',
  PERISHABLE: 'PERISHABLE',
  PHARMA: 'PHARMA',
} as const;
export type CargoTypeSub = (typeof CargoTypeSub)[keyof typeof CargoTypeSub];
export const VariantType = {
  General: 'General',
  Expedited: 'Expedited',
  Urgent: 'Urgent',
  Other: 'Other',
} as const;
export type VariantType = (typeof VariantType)[keyof typeof VariantType];
export const AircraftType = {
  Freighter: 'Freighter',
  WideBody: 'WideBody',
  NarrowBody: 'NarrowBody',
  RFS: 'RFS',
} as const;
export type AircraftType = (typeof AircraftType)[keyof typeof AircraftType];
export const BacklogStatus = {
  None: 'None',
  AtRisk: 'AtRisk',
  Backlogged: 'Backlogged',
} as const;
export type BacklogStatus = (typeof BacklogStatus)[keyof typeof BacklogStatus];
export const QuoteSource = {
  ECHO: 'ECHO',
  NEXTGEN: 'NEXTGEN',
  FORWARDAIR: 'FORWARDAIR',
  GLOBALTRANZ: 'GLOBALTRANZ',
  EK: 'EK',
  AC: 'AC',
  QR: 'QR',
  SEVENLFREIGHT: 'SEVENLFREIGHT',
  TK: 'TK',
  SYSTEM: 'SYSTEM',
} as const;
export type QuoteSource = (typeof QuoteSource)[keyof typeof QuoteSource];
export const SourceType = {
  GOOGLE_SHEETS: 'GOOGLE_SHEETS',
} as const;
export type SourceType = (typeof SourceType)[keyof typeof SourceType];
export const RateImportState = {
  PENDING: 'PENDING',
  RUNNING: 'RUNNING',
  ERROR: 'ERROR',
  SUCCESS: 'SUCCESS',
  EXPIRED: 'EXPIRED',
} as const;
export type RateImportState = (typeof RateImportState)[keyof typeof RateImportState];
export const RateImportAction = {
  EXTEND: 'EXTEND',
  EXPIRE: 'EXPIRE',
} as const;
export type RateImportAction = (typeof RateImportAction)[keyof typeof RateImportAction];
export const CargoCoolingRange = {
  NEGATIVE_TEN_TO_NEGATIVE_TWENTY_CELSIUS: 'NEGATIVE_TEN_TO_NEGATIVE_TWENTY_CELSIUS',
  TWO_TO_EIGHT_CELSIUS: 'TWO_TO_EIGHT_CELSIUS',
  TWO_TO_TWENTY_FIVE_CELSIUS: 'TWO_TO_TWENTY_FIVE_CELSIUS',
  FIFTEEN_TO_TWENTY_FIVE_CELSIUS: 'FIFTEEN_TO_TWENTY_FIVE_CELSIUS',
} as const;
export type CargoCoolingRange = (typeof CargoCoolingRange)[keyof typeof CargoCoolingRange];
export const CargoCooling = {
  GEL_PACKS: 'GEL_PACKS',
  DRY_ICE: 'DRY_ICE',
  NO_COOLING: 'NO_COOLING',
} as const;
export type CargoCooling = (typeof CargoCooling)[keyof typeof CargoCooling];
export const DocumentType = {
  DGD: 'DGD',
  MSDS: 'MSDS',
  AIRWAY_BILL: 'AIRWAY_BILL',
  SHIPPER_DOCUMENTS: 'SHIPPER_DOCUMENTS',
  SLI: 'SLI',
  BOL: 'BOL',
  LABELS: 'LABELS',
  PROVIDER_SPOT_QUOTE: 'PROVIDER_SPOT_QUOTE',
  OTHER: 'OTHER',
  MANIFEST: 'MANIFEST',
  HOUSE_AIRWAY_BILL: 'HOUSE_AIRWAY_BILL',
  INVOICE: 'INVOICE',
} as const;
export type DocumentType = (typeof DocumentType)[keyof typeof DocumentType];
export const AircraftRestriction = {
  CAO: 'CAO',
  PAX: 'PAX',
} as const;
export type AircraftRestriction = (typeof AircraftRestriction)[keyof typeof AircraftRestriction];
export const PackingGroup = {
  I: 'I',
  II: 'II',
  III: 'III',
} as const;
export type PackingGroup = (typeof PackingGroup)[keyof typeof PackingGroup];
export const PackingInstruction = {
  PI965: 'PI965',
  PI966: 'PI966',
  PI967: 'PI967',
  PI968: 'PI968',
  PI969: 'PI969',
  PI970: 'PI970',
} as const;
export type PackingInstruction = (typeof PackingInstruction)[keyof typeof PackingInstruction];
export const Section = {
  I: 'I',
  II: 'II',
  IA: 'IA',
  IB: 'IB',
} as const;
export type Section = (typeof Section)[keyof typeof Section];
export const BatteryType = {
  DG_BATTERIES_IN_EQUIPMENT: 'DG_BATTERIES_IN_EQUIPMENT',
  NON_RESTRICTED_BATTERIES_IN_EQUIPMENT: 'NON_RESTRICTED_BATTERIES_IN_EQUIPMENT',
} as const;
export type BatteryType = (typeof BatteryType)[keyof typeof BatteryType];
export const BusinessType = {
  FREIGHT_FORWARDER: 'FREIGHT_FORWARDER',
  GSA: 'GSA',
  AIRLINE: 'AIRLINE',
} as const;
export type BusinessType = (typeof BusinessType)[keyof typeof BusinessType];
export const TrackingShipmentStatus = {
  ACTIVE: 'ACTIVE',
  REPLACED: 'REPLACED',
  COMPLETED: 'COMPLETED',
} as const;
export type TrackingShipmentStatus = (typeof TrackingShipmentStatus)[keyof typeof TrackingShipmentStatus];
export const TimeOfDay = {
  MORNING: 'MORNING',
  MID_DAY: 'MID_DAY',
  EVENING: 'EVENING',
} as const;
export type TimeOfDay = (typeof TimeOfDay)[keyof typeof TimeOfDay];
export const AccountType = {
  IATA: 'IATA',
  IAC: 'IAC',
  UNCERTIFIED: 'UNCERTIFIED',
  ORGANIZATION: 'ORGANIZATION',
} as const;
export type AccountType = (typeof AccountType)[keyof typeof AccountType];
export const AccountWebhookEvent = {
  QUOTE_READY_FOR_REVIEW: 'QUOTE_READY_FOR_REVIEW',
} as const;
export type AccountWebhookEvent = (typeof AccountWebhookEvent)[keyof typeof AccountWebhookEvent];
export const RateLimitBucketType = {
  CREATE_REQUEST: 'CREATE_REQUEST',
  GENERIC_FETCH: 'GENERIC_FETCH',
} as const;
export type RateLimitBucketType = (typeof RateLimitBucketType)[keyof typeof RateLimitBucketType];
export const ContactType = {
  INDIVIDUAL: 'INDIVIDUAL',
  ORGANIZATION: 'ORGANIZATION',
} as const;
export type ContactType = (typeof ContactType)[keyof typeof ContactType];
export const EarliestTenderOption = {
  ANYTIME: 'ANYTIME',
  TWENTY_FOUR_HOURS: 'TWENTY_FOUR_HOURS',
  FOURTY_EIGHT_HOURS: 'FOURTY_EIGHT_HOURS',
  SEVENTY_TWO_HOURS: 'SEVENTY_TWO_HOURS',
} as const;
export type EarliestTenderOption = (typeof EarliestTenderOption)[keyof typeof EarliestTenderOption];
export const NotificationCategory = {
  Quote: 'Quote',
  Booking: 'Booking',
  All: 'All',
  Primary: 'Primary',
  Marketplace: 'Marketplace',
  TrackAndTrace: 'TrackAndTrace',
} as const;
export type NotificationCategory = (typeof NotificationCategory)[keyof typeof NotificationCategory];
export const DayOfWeek = {
  MONDAY: 'MONDAY',
  TUESDAY: 'TUESDAY',
  WEDNESDAY: 'WEDNESDAY',
  THURSDAY: 'THURSDAY',
  FRIDAY: 'FRIDAY',
  SATURDAY: 'SATURDAY',
  SUNDAY: 'SUNDAY',
} as const;
export type DayOfWeek = (typeof DayOfWeek)[keyof typeof DayOfWeek];
export const FreightServiceAddOn = {
  AES: 'AES',
} as const;
export type FreightServiceAddOn = (typeof FreightServiceAddOn)[keyof typeof FreightServiceAddOn];
export const FreightService = {
  AFR: 'AFR',
  EXW: 'EXW',
  FCA: 'FCA',
} as const;
export type FreightService = (typeof FreightService)[keyof typeof FreightService];
export const IATAFlightSegmentStatus = {
  AS: 'AS',
  CA: 'CA',
  HK: 'HK',
  HL: 'HL',
  HN: 'HN',
  KK: 'KK',
  LL: 'LL',
  NA: 'NA',
  NL: 'NL',
  NN: 'NN',
  SS: 'SS',
  UN: 'UN',
  UU: 'UU',
  QU: 'QU',
  KL: 'KL',
  KC: 'KC',
  LA: 'LA',
  XX: 'XX',
  CN: 'CN',
  AA: 'AA',
  NS: 'NS',
} as const;
export type IATAFlightSegmentStatus = (typeof IATAFlightSegmentStatus)[keyof typeof IATAFlightSegmentStatus];
export const FlightSegmentBookingStatus = {
  Pending: 'Pending',
  Confirmed: 'Confirmed',
  Cancelled: 'Cancelled',
  Unknown: 'Unknown',
} as const;
export type FlightSegmentBookingStatus = (typeof FlightSegmentBookingStatus)[keyof typeof FlightSegmentBookingStatus];
export const IdentitySystem = {
  IATA: 'IATA',
  SCAC: 'SCAC',
  USDOT: 'USDOT',
  MC: 'MC',
} as const;
export type IdentitySystem = (typeof IdentitySystem)[keyof typeof IdentitySystem];
